import React from "react";
import { FeatureIconContainer } from "../components/features/feature-icon-container";
import { IconReceiptFilled } from "@tabler/icons-react";
import { Heading } from "../components/ui/heading";
import { Subheading } from "../components/ui/subheading";
import { Contact2 } from "lucide-react";
import { CardSpotlight } from "../components/animations/card-spotlight";
import { GlareCard } from "../components/animations/glare-card";

const WhyJoin = () => {
  return (
    <div>
      <div className="relative z-20" data-aos="fade-down">
        <FeatureIconContainer className="flex justify-center items-center overflow-hidden">
          <Contact2 className="h-6 w-6 text-fuchsia-700" />
        </FeatureIconContainer>
        <Heading className="mt-4">Why join the affiliate program?</Heading>
        <Subheading className="w-full max-w-lg mx-auto">
          Join hands with us to be a part of our journey in reaching out to
          merchants with our products that we deeply believe in, and in the
          process take advantage of our commission structure to earn the reward
          you deserve.
        </Subheading>
      </div>
      <div className="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-2 mt-16">
        <div className="w-full flex justify-center items-center">
          <GlareCard className="flex flex-col items-center justify-end py-8 px-6">
            <div className="flex gap-4 w-full justify-start items-end">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-10 text-fuchsia-600 animate-bounce"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z"
                />
              </svg>
              <p className="font-bold text-white text-lg w-full">
                High-Demand Product
              </p>
            </div>
            <p className="font-normal text-base text-neutral-200 mt-4 w-full">
              Our leading WooCommerce plugin is proven and trusted, ensuring top
              earning potential from every sale.
            </p>
          </GlareCard>
        </div>
        <div className="w-full flex justify-center items-center">
          <GlareCard className="flex flex-col items-center justify-end py-8 px-6">
            <div className="flex gap-4 w-full justify-start items-end">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-10 text-fuchsia-600 animate-bounce"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
                />
              </svg>

              <p className="font-bold text-white text-lg w-full">
                Competitive Commissions
              </p>
            </div>
            <p className="font-normal text-base text-neutral-200 mt-4 w-full">
              Enjoy competitive commissions and tailored packages that maximize
              the value of each referral.
            </p>
          </GlareCard>
        </div>
        <div className="w-full flex justify-center items-center">
          <GlareCard className="flex flex-col items-center justify-end py-8 px-6">
            <div className="flex gap-4 w-full justify-start items-end">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-10 text-fuchsia-600 animate-bounce"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M7.5 7.5h-.75A2.25 2.25 0 0 0 4.5 9.75v7.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-7.5a2.25 2.25 0 0 0-2.25-2.25h-.75m-6 3.75 3 3m0 0 3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25h-7.5a2.25 2.25 0 0 1-2.25-2.25v-.75"
                />
              </svg>

              <p className="font-bold text-white text-lg w-full">
                Marketing Support
              </p>
            </div>
            <p className="font-normal text-base text-neutral-200 mt-4 w-full">
              Access marketing materials, guides, and unique links to enhance
              your promotional efforts with ease.
            </p>
          </GlareCard>
        </div>
        <div className="w-full flex justify-center items-center">
          <GlareCard className="flex flex-col items-center justify-end py-8 px-6">
            <div className="flex gap-4 w-full justify-start items-end">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-10 text-fuchsia-600 animate-bounce"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672Zm-7.518-.267A8.25 8.25 0 1 1 20.25 10.5M8.288 14.212A5.25 5.25 0 1 1 17.25 10.5"
                />
              </svg>
              <p className="font-bold text-white text-lg w-full">
                Quick Sign-Up
              </p>
            </div>
            <p className="font-normal text-base text-neutral-200 mt-4 w-full">
              Fill out the form, get your referral link, and start earning right
              away with easy performance tracking.
            </p>
          </GlareCard>
        </div>
        <div className="w-full flex justify-center items-center">
          <GlareCard className="flex flex-col items-center justify-end py-8 px-6">
            <div className="flex gap-4 w-full justify-start items-end">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-10 text-fuchsia-600 animate-bounce"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
                />
              </svg>
              <p className="font-bold text-white text-lg w-full">
                Extended Earnings
              </p>
            </div>
            <p className="font-normal text-base text-neutral-200 mt-4 w-full">
              A 90-day cookie window gives you plenty of time to earn
              commissions on each referral.
            </p>
          </GlareCard>
        </div>
      </div>
    </div>
  );
};

export default WhyJoin;
